module.exports = __webpack_public_path__ + "img/upload1.54dfeb6a.svg";